// LocationPermission.tsx

import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import LocationPermissionFetch from "src/components/LocationPermissionFetch";
import { getMobileOperatingSystem } from 'src/utils/helper';
// Define the props interface
interface LocationPermissionProps {
  onLocationGranted: (coords: { lat: number; long: number }) => void;
  onError: (errorMessage: string) => void;
}

const LocationPermission: React.FC<LocationPermissionProps> = ({ onLocationGranted, onError }) => {
  
  const [showModal, setShowModal] = useState<boolean>(false); // Don't show modal initially
  const [locationPermissionGranted, setLocationPermissionGranted] = useState<boolean>(false);
  const [showSystemLevelPermissionModal, setSystemLevelPermissionModal] = useState<boolean>(false); // Don't show modal initially
  const deviceType = getMobileOperatingSystem();
  // Function to check if permission was already granted or denied

  // Function to get the user's location
  const getLocation = () => {
    if (navigator.geolocation) {
      
      // Request for location permission and get coordinates
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          onLocationGranted({ lat: latitude, long: longitude });
          setShowModal(false); // Close modal after permission
          localStorage.setItem('locationPermissionGranted', 'true'); // Store the granted state
          setLocationPermissionGranted(true)
          localStorage.setItem('geolocation',JSON.stringify({ lat: latitude, long: longitude }))
        },
        (err) => {
          if(err.PERMISSION_DENIED && deviceType === 2  && localStorage.getItem('systemLevelPoupShown') !== 'true') {
            setSystemLevelPermissionModal(true)
          }
          onError(err.message);
          setShowModal(false); // Close modal on error
        }
      );

    } else {
      localStorage.removeItem('geolocation')
      onError('Geolocation is not supported by this device.');
      setShowModal(false);
    }
  };

  const handleAllow = () => {
   // getLocation()
    setShowModal(false)
    setLocationPermissionGranted(true)
  };

  const handleDeny = () => {
    onError('You denied the location access.');
    setShowModal(false); // Close modal when user denies permission
    localStorage.setItem('locationPermissionDenied', 'true'); // Store the denied state
    setLocationPermissionGranted(true)
  };
  useEffect(() => {
    checkCurrentLocPermission()
  })

  const checkCurrentLocPermission = async() => {
    
    if (navigator.geolocation) {
      const status = await navigator.permissions.query({ name: 'geolocation' });
        if(status.state === 'prompt' && !locationPermissionGranted && localStorage.getItem('locationPermissionDenied') !== 'true' ) {
           setShowModal(true);
        } else if(status.state === 'granted') {
          setLocationPermissionGranted(true)
          localStorage.removeItem('locationPermissionDenied');
          getLocation()
        } else if(status.state === 'denied') {
          setShowModal(false);
          localStorage.removeItem('geolocation')
          onLocationGranted({ lat: '', long: '' });
        }  else if(status.state === 'prompt' && locationPermissionGranted && deviceType === 2 && localStorage.getItem('systemLevelPoupShown') !== 'true') { //Show ios system level permission message
          setShowModal(false);
          setSystemLevelPermissionModal(true)
        }
    }
  };
  const onAllow = async() => {
    localStorage.removeItem('locationPermissionDenied');
    setLocationPermissionGranted(true)
    setShowModal(false);
    checkCurrentLocPermission()
  }
  const hideSystemLevelInfoPopup = async() => {
    setShowModal(false);
    setSystemLevelPermissionModal(false)
    localStorage.setItem('systemLevelPoupShown','true')
  }
  return (
    <>
  
    {((locationPermissionGranted || localStorage.getItem('locationPermissionGranted') === 'true') && localStorage.getItem('locationPermissionDenied') !== 'true' ) ? <LocationPermissionFetch onAllow = {onAllow}/> : ''}
      <Modal show={showModal} onHide={handleDeny} centered className='notification-modal'>
        <Modal.Body className='text-center'>
            <h6>The Car Wash App requires your location info to function properly. Please allow the Location permission for the app.</h6>
            
        </Modal.Body>
        <Modal.Footer className='d-grid'>
          <Button variant="light" className='m-0' onClick={handleDeny}>Don't Allow</Button>
          <Button variant="primary" className="primary-btn btn-main m-0" onClick={handleAllow}>Allow</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showSystemLevelPermissionModal} onHide={hideSystemLevelInfoPopup} centered className='notification-modal'>
        <Modal.Body className='text-center'>
            <h6>The Car Wash App requires your location info to function properly. Please allow the Location permission for the app.</h6>
            <p>For updating this, go to Settings > Privacy & Security > Location Services and turn on Location Services. </p>
            
        </Modal.Body>
        <Modal.Footer className='d-flex justify-content-center'>
          <Button variant="primary" className="primary-btn btn-main m-0 " onClick={hideSystemLevelInfoPopup}>Okay</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LocationPermission;
